import "./lisibility.css"
import React from "react";


import { GlobalContext } from "../../../../utils/globalprovider";
import { getLisibility } from "../../../../utils/checksubtitles";


import imglisblue from "./assets/bluesimplified.png"
import imglisgreen from "./assets/greensimplified.png"
import imglisred from "./assets/redsimplified.png"

import imgbluecursor from "./assets/bluecursor.png"
import imggreencursor from "./assets/greencursor.png"
import imgredcursor from "./assets/redcursor.png"



import imglistgauge from "./assets/lisgauge5.png"

class Lisibility extends React.Component
{

    static contextType = GlobalContext;
    constructor (props)
    {
        super(props);


        this.state = {
            lisibility:null,
        };
    }
     

    
    componentDidUpdate(previousProps)
    {
        //if (!this.props.simplified) this.drawLisibility();
        if (this.props.subtitle !== previousProps.subtitle)    
        {
            if ((this.props.subtitle) && (this.props.stparams) )
                this.setState({lisibility:getLisibility(this.props.subtitle,this.props.stparams, this.context.language)});
            else
                this.setState({lisibility:null});
        }

    }
    componentDidMount()
    {
        var lisibility = null;
        if ((this.props.subtitle) && (this.props.stparams) )
            lisibility = getLisibility(this.props.subtitle,this.props.stparams, this.context.language);
        this.setState({lisibility:lisibility});
        
    }



    setSubtitle(subtitle, stparams)
    {
    }


    

    render()
    {
        
        if (this.state.lisibility === null) 
        {
            return (<></>);
        }

      
        var img = null;
        

        const text = String(this.state.lisibility.value+"/"+this.state.lisibility.max)
        if (this.props.simplified)
        {
            // savant calcul
            if (this.state.lisibility.value < this.state.lisibility.ideal )
                img = imglisblue;
            else
                if (this.state.lisibility.value > this.state.lisibility.max)
                    img = imglisred;
                else
                    img = imglisgreen;
            return ( 
                <div className="visibility-div" style={
                    {   marginTop:"3px",
                        width:"45px",height:"14px",
                        backgroundImage: `url(${img})`,
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        fontSize:"9px",
                    }}>
                        
                    {text}
                </div>
            )

        }
        // savant calcul
        if (this.state.lisibility.value < this.state.lisibility.ideal )
            img = imgbluecursor;
        else
            if (this.state.lisibility.value > this.state.lisibility.max)
                img = imgredcursor;
            else
                img = imggreencursor;

        const max = 58;
        const min = 0;
        const startgreen = 19;
        const startred = 39;

        const bluewidth = startgreen - min;
        const greenwidth = startred - startgreen;
        const redwidth = max - startred;

        var posx = 0;
        var value = this.state.lisibility.value;
        value = Math.min (value, 80);

        if (this.state.lisibility.value < this.state.lisibility.ideal )
            posx =(value * bluewidth) / this.state.lisibility.ideal;
        else
            if (this.state.lisibility.value > this.state.lisibility.max)
            {
                value = value - this.state.lisibility.max;
                posx = startred + (value * redwidth) / (80 - this.state.lisibility.max);
            }
            else
            {
                value = value - this.state.lisibility.ideal;
                var plage = this.state.lisibility.max - this.state.lisibility.ideal;
                if (plage < 1) plage=1;

                posx = startgreen + (value * greenwidth) / (this.state.lisibility.max - this.state.lisibility.ideal);

            }
    
        
        posx = Math.min(posx, max);
        posx = Math.max(posx,min);

        posx = String(posx) + "px";

        return ( 
            <div className="visibility-div" style={
                {   
                    width:"93px",height:"32px",
                    backgroundImage: `url(${imglistgauge})`,
                    backgroundSize: "100% 100%",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    overflow: "hidden",                        
                }}>


                <div style={
                    {   
                        position: "absolute",
                        width:"35px",height:"22px",
                        left:posx, top:"2px",
                        fontSize:"8px",
                        backgroundImage: `url(${img})`,
                        backgroundSize: "100% 100%",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        overflow: "hidden",
                    }}>
                        
                    {text}
                </div>
            </div>
        )

    }
};

Lisibility.defaultProps = {
    simplified: true,
}

export default Lisibility;

